import React, { useState, useMemo, useEffect } from "react";
import {
    Box,
    Stack,
    Card,
    CardContent,
    CardHeader,
    Typography,
    Switch,
    Badge,
} from "@mui/material";
import { Button, TextField, MenuItem, Select, InputLabel, FormControl, CircularProgress } from "@mui/material";
import {
    Notifications as Bell,
    Search,
    FilterList as Filter,
    Add as Plus,
    Visibility as Eye,
    Group as Users,
    ReportProblem as AlertTriangle,
    Timeline as Activity,
    CheckCircle,
    VisibilityOff,
    AccessTime as Clock,
    ReadMore
} from "@mui/icons-material";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
// import Link from "next/link";
import { format } from "date-fns";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import CancelModal from "../../Components/CancelModal";

// Zëvendësim për hook dhe utils që nuk i ke
const useAppLevelAuth = () => ({ isLoggedIn: true });
const useToast = () => ({
    toast: ({ title, description }) => alert(`${title}\n${description}`)
});

export default function ManageNotifications({ getData, onEdit }) {
    const { toast } = useToast();
    const headers = authHeader();
    const [notifications, setNotifications] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterActive, setFilterActive] = useState("all");
    const [filterVisibleTo, setFilterVisibleTo] = useState("all");
    const [filterVersion, setFilterVersion] = useState("all");
    const [filterPriority, setFilterPriority] = useState("all");

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showTop10Button, setShowTop10Button] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [deleteID, setDeleteid] = useState("");

    const [role, setRole] = useState("");


    const fetchAllUserNotification = async (type) => {
        if (type === "all") {
            setIsSubmitting(true);
            setShowTop10Button(false);
        } else {
            setIsSubmitting(false);
            setShowTop10Button(true);
        }
        try {
            const response = await axios.get(ApiLink.API_URL + 'Notification/allNotification', { headers, params: { type: type } });
            // setCompanyID(response.data[0].CompanyID);
            setNotifications(response.data);
            setIsSubmitting(false);

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            setIsSubmitting(false);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const deleteNotification = async (id) => {
        try {
            const response = await axios.delete(`${ApiLink.API_URL}Notification/${id}`, { headers })
            handleSuccess("notifikimi u fshi me sukses")
            fetchAllUserNotification("top");
            setDeleteid("");
            setShowModal(false);
        }
        catch (e) {
            errorAlert("Nuk eshte fshire notifikimi")
        }
    }

    // const toggleActive = (id) => {
    //     setNotifications((prev) =>
    //         prev.map((notif) =>
    //             notif.id === id ? { ...notif, isActive: !notif.isActive } : notif
    //         )
    //     );

    //     const notification = notifications.find((n) => n.id === id);
    //     toast({
    //         title: "Status Updated",
    //         description: `Notification "${notification?.title}" is now ${notification?.isActive ? "inactive" : "active"
    //             }`,
    //     });
    // };

    const fetchRole = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });

            if (response.data.UserRole && response.data.UserRole !== undefined) {
                setRole(response.data.UserRole);
            } else {
                errorAlert("Undefined Role.");
            }
        } catch (error) {
            console.error("Error fetching role:", error);
            // ... (pjesa tjetër e kodit)
        }
    };

    const markAsRead = (id) => {
        setNotifications((prev) =>
            prev.map((notif) =>
                notif.id === id ? { ...notif, isRead: true } : notif
            )
        );
    };

    const filteredNotifications = useMemo(() => {
        return notifications.filter((notification) => {
            const matchesSearch =
                notification.Title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                notification.Message.toLowerCase().includes(searchTerm.toLowerCase());
            // (notification.version &&
            //     notification.version.toLowerCase().includes(searchTerm.toLowerCase()));

            const matchesActive =
                filterActive === "all" ||
                (filterActive === "active" && notification.IsActive) ||
                (filterActive === "inactive" && !notification.IsActive);

            const matchesVisibleTo =
                filterVisibleTo === "all" || notification.VisibleTo === filterVisibleTo;

            const matchesVersion =
                filterVersion === "all" || notification.Version === filterVersion;

            // const matchesPriority =
            //     filterPriority === "all" || notification.priority === filterPriority;

            return (
                matchesSearch &&
                matchesActive &&
                matchesVisibleTo &&
                matchesVersion
                // matchesPriority
            );
        });
    }, [
        notifications,
        searchTerm,
        filterActive,
        filterVisibleTo,
        filterVersion
        // filterPriority,
    ]);

    // const getPriorityColor = (priority) => {
    //     switch (priority) {
    //         case "urgent":
    //             return "#f8d7da"; // red
    //         case "high":
    //             return "#fff3cd"; // orange
    //         case "medium":
    //             return "#d1ecf1"; // blue
    //         case "low":
    //             return "#e2e3e5"; // gray
    //         default:
    //             return "#e2e3e5";
    //     }
    // };

    const getVisibilityIcon = (visibleTo) => {
        switch (visibleTo) {
            case "All":
                return <Users fontSize="small" />;
            case "Admins":
                return <AlertTriangle fontSize="small" />;
            case "Staff":
                return <Activity fontSize="small" />;
            case "Custom":
                return <Users fontSize="small" />;
            default:
                return <Users fontSize="small" />;
        }
    };

    // const fetchAllUserNotification = async () => {
    //     try {
    //         const response = await axios.get(ApiLink.API_URL + 'Notification/allNotification', { headers });
    //         // setCompanyID(response.data[0].CompanyID);
    //         setNotifications(response.data);
    //         console.log(response.data);
    //     } catch (error) {
    //         errorAlert("Gabim në kërkesë:", error);

    //         if (error.response && error.response.data && error.response.data.errorMessage) {
    //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
    //         } else if (error.message) {
    //             errorAlert(`Gabim: ${error.message}`);
    //         } else {
    //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
    //         }
    //     }
    // };


    // if (!isLoggedIn) return null;


    const updateStatusNtfc = async (id) => {
        try {
            const response = await axios.put(
                ApiLink.API_URL + `Notification/statusNotification/${id}`,
                null, // ose {} — pasi nuk ka `data`
                { headers }
            );
            // handleSuccess("u editua");
            fetchAllUserNotification("top");

        } catch (e) {
            // errorAlert("Nuk është modifikuar", e.response);
        }
    };


    const uniqueVersions = [...new Set(notifications.map((n) => n.Version).filter(Boolean))];

    useEffect(() => {
        fetchAllUserNotification("top");
        fetchRole();
    }, [getData]);

    return (
        <>
            <CancelModal
                open={showModal}
                onClose={() => setShowModal(false)}
                title="Konfirmim"
                description="Jeni të sigurt që dëshironi të fshini njoftimin?"
                confirmText="po"     // Custom confirm button text
                cancelText="jo"      // Custom cancel button text
                onConfirm={() => deleteNotification(deleteID)}
            />


            <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>

                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", lg: "row" },
                        justifyContent: "space-between",
                        alignItems: { lg: "center" },
                        gap: 2,
                    }}
                >
                    <Box>
                        <Typography variant="h4" fontWeight="bold" color="text.primary">
                            Lista e njoftimeve
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mt={0.5}>
                            Shiko dhe Filtro listen e njoftimeve
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h4" fontWeight="bold" color="text.primary">
                            <Button
                                type="button"
                                variant="contained"
                                onClick={() => { showTop10Button ? fetchAllUserNotification("all") : fetchAllUserNotification("top") }}
                                disabled={isSubmitting}
                                startIcon={isSubmitting ? <CircularProgress size={20} /> : <ManageSearchIcon />}
                                fullWidth
                            >
                                {isSubmitting ? "Duke u procesuar" : (showTop10Button ? "Shfaq të gjitha njoftimet" : "Refresh")}
                            </Button>
                        </Typography>
                    </Box>
                    {/* <Link href="/create-notification" passHref>
                    <Button
                        variant="contained"
                        startIcon={<Plus />}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        Create Notification
                    </Button>
                </Link> */}
                </Box>

                {/* Filters */}
                <Card variant="outlined" sx={{ boxShadow: 1 }}>
                    <CardHeader
                        title={
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Filter fontSize="small" />
                                <Typography variant="h6">Filtrim</Typography>
                            </Stack>
                        }
                    />
                    <CardContent sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                        {/* Search */}
                        <Box>
                            <TextField
                                fullWidth
                                id="search"
                                label="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Search notifications..."
                                InputProps={{
                                    startAdornment: <Search sx={{ mr: 1, color: "text.disabled" }} />,
                                }}
                                size="small"
                            />
                        </Box>

                        {/* Filter Row */}
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    md: "1fr 1fr",
                                    lg: "repeat(3, 1fr)",
                                },
                                gap: 2,
                            }}
                        >
                            {/* Active Status */}
                            <FormControl size="small" fullWidth>
                                <InputLabel>Statusi</InputLabel>
                                <Select
                                    label="Status"
                                    value={filterActive}
                                    onChange={(e) => setFilterActive(e.target.value)}
                                >
                                    <MenuItem value="all">All Status</MenuItem>
                                    <MenuItem value="active">Active Only</MenuItem>
                                    <MenuItem value="inactive">Inactive Only</MenuItem>
                                </Select>
                            </FormControl>

                            {/* Visible To */}
                            <FormControl size="small" fullWidth>
                                <InputLabel>Audienca</InputLabel>
                                <Select
                                    label="Visible To"
                                    value={filterVisibleTo}
                                    onChange={(e) => setFilterVisibleTo(e.target.value)}
                                >
                                    <MenuItem value="all">All Users</MenuItem>
                                    <MenuItem value="All">All Users</MenuItem>
                                    <MenuItem value="Admins">Admins Only</MenuItem>
                                    <MenuItem value="Staff">Staff Only</MenuItem>
                                    <MenuItem value="Custom">Custom</MenuItem>
                                </Select>
                            </FormControl>

                            {/* Version */}
                            <FormControl size="small" fullWidth>
                                <InputLabel>Version</InputLabel>
                                <Select
                                    label="Version"
                                    value={filterVersion}
                                    onChange={(e) => setFilterVersion(e.target.value)}
                                >
                                    <MenuItem value="all">All Versions</MenuItem>
                                    {uniqueVersions.map((version) => (
                                        <MenuItem key={version} value={version}>
                                            {version}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Priority */}
                            {/* <FormControl size="small" fullWidth>
                                <InputLabel>Priority</InputLabel>
                                <Select
                                    label="Priority"
                                    value={filterPriority}
                                    onChange={(e) => setFilterPriority(e.target.value)}
                                >
                                    <MenuItem value="all">All Priorities</MenuItem>
                                    <MenuItem value="urgent">Urgent</MenuItem>
                                    <MenuItem value="high">High</MenuItem>
                                    <MenuItem value="medium">Medium</MenuItem>
                                    <MenuItem value="low">Low</MenuItem>
                                </Select>
                            </FormControl> */}
                        </Box>

                        {/* Results Count */}
                        <Typography variant="body2" color="text.secondary">
                            Te shfaqura {filteredNotifications.length} / {notifications.length} njoftime
                        </Typography>
                    </CardContent>
                </Card>

                {/* Notifications List */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {filteredNotifications.length === 0 ? (
                        <Card variant="outlined" sx={{ boxShadow: 1 }}>
                            <CardContent
                                sx={{
                                    textAlign: "center",
                                    py: 6,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 2,
                                    color: "text.disabled",
                                }}
                            >
                                <Bell sx={{ fontSize: 48 }} />
                                <Typography variant="h6" color="text.primary">
                                    Nuk ka asnje njoftim per ta shfaqur
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {searchTerm ||
                                        filterActive !== "all" ||
                                        filterVisibleTo !== "all" ||
                                        filterVersion !== "all"
                                        // filterPriority !== "all"
                                        ? "Try adjusting your filters to see more results"
                                        : "Create your first notification to get started"}
                                </Typography>
                                {/* <Link href="/create-notification" passHref>
                                <Button
                                    variant="contained"
                                    startIcon={<Plus />}
                                    sx={{ mt: 2 }}
                                >
                                    Create Notification
                                </Button>
                            </Link> */}
                            </CardContent>
                        </Card>
                    ) : (
                        filteredNotifications.map((notification) => (
                            <Card
                                key={notification.NotificationStatusID}
                                variant="outlined"
                                sx={{
                                    boxShadow: 1,
                                    transition: "box-shadow 0.3s ease",
                                    bgcolor: !notification.IsRead ? "action.hover" : "background.paper",
                                    borderColor: !notification.IsRead ? "primary.light" : "divider",
                                    "&:hover": {
                                        boxShadow: 4,
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 3 }}>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            {/* Header */}
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                                <Typography
                                                    noWrap
                                                    variant="subtitle1"
                                                    fontWeight="bold"
                                                    color={!notification.IsRead ? "text.primary" : "text.secondary"}
                                                >
                                                    {notification.Title}
                                                </Typography>
                                                {!notification.IsRead && (
                                                    <Box
                                                        sx={{
                                                            width: 8,
                                                            height: 8,
                                                            bgcolor: "primary.main",
                                                            borderRadius: "50%",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                )}
                                            </Box>

                                            {/* Message */}
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 10,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {notification.Message}
                                            </Typography>

                                            {/* Metadata */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 2,
                                                    mt: 1,
                                                    alignItems: "center",
                                                    fontSize: "0.875rem",
                                                    color: "text.secondary",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                    <Clock fontSize="small" />
                                                    <Typography>
                                                        {format(new Date(notification.CreatedDate), "MMM d, yyyy 'at' h:mm a")}
                                                    </Typography>
                                                </Box>

                                                {notification.Version && (
                                                    <Badge
                                                        variant="outlined"
                                                        sx={{
                                                            fontSize: 15,
                                                            borderColor: "text.secondary",
                                                            color: "text.secondary",
                                                        }}
                                                    >
                                                        {notification.Version}
                                                    </Badge>
                                                )}

                                                {/* <Badge
                                                    variant="outlined"
                                                    sx={{
                                                        fontSize: 10,
                                                        bgcolor: getPriorityColor(notification.Priority),
                                                        color: "text.primary",
                                                        borderColor: "transparent",
                                                    }}
                                                >
                                                    {notification.priority}
                                                </Badge> */}

                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                    {getVisibilityIcon(notification.VisibleTo)}
                                                    <Typography>
                                                        {notification.VisibleTo === "Custom"
                                                            ? notification.customCompanyId
                                                            : notification.VisibleTo}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Actions */}
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexShrink: 0 }}>
                                            {!notification.IsRead && (
                                                <Button
                                                    size="small"
                                                    variant="text"
                                                    color="primary"
                                                    startIcon={<ReadMore />}
                                                    onClick={() => updateStatusNtfc(notification.NotificationStatusID)}
                                                >
                                                    Shëno si e lexuar
                                                </Button>
                                            )}
                                            {
                                                role === "acctree" && (
                                                    <>
                                                        <Tooltip title="Delete">
                                                            <IconButton
                                                                size="small"
                                                                color="error"
                                                                onClick={() => { setDeleteid(notification.NotificationID); setShowModal(true) }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Tooltip title="Edit">
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={() => onEdit(notification)}
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )
                                            }
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                    )}
                </Box>
            </Box>
        </>
    );
}
